@if (data?.results && data.results.length > 0) {
  <ul class="parking-results-list results-width">
    @for (item of data?.results | parkingPriceSort; track item; let index = $index) {
      <li>
        <div
          class="pnl-item"
          role="group"
          [attr.aria-label]="'Parking option ' + (index + 1) + ': ' + item.carPark.name"
        >
          <div class="flex-row-container flex-row-container--between">
            <div class="pnl-desc">
              <h3>{{ item.carPark.name }}</h3>
              <app-preferred-icons
                [tmcPreferred]="item.tmcPreferred"
                [tmcPreferredLogoUrl]="item.tmcPreferredLogoUrl"
                [tmcPreferredMessage]="item.tmcPreferredMessage"
                [clientPreferred]="item.officePreferred || item.companyPreferred"
                [companyPreferredMessage]="item.companyPreferredMessage"
                [officePreferredMessage]="item.officePreferredMessage"
              >
              </app-preferred-icons>
              <div class="parking-filters">
                @for (type of item?.carPark | parkingFilters; track type) {
                  @if (type) {
                    <div><i class="ico-check-1 light-color-primary"></i>{{ type | translate }}</div>
                  }
                }
              </div>
              <div class="parking-tip">
                <div class="parking-text">
                  @if (
                    item.carPark.misc.seoPageTransferTime ||
                    (item.carPark.misc.transferFrequency &&
                      item.carPark.misc.transferFrequency !== '0')
                  ) {
                    <span i18n="@@pnltransfersRun">Transfers run</span>
                    <span class="light-fat light-color-primary">
                      @if (item.carPark.misc.transferFrequency) {
                        <span i18n="@@pnlEvery">every</span>
                      }
                      {{ item.carPark.misc.transferFrequency }}
                      mins</span
                    >
                    @if (!item.carPark.misc.transferFrequency) {
                      <span class="light-fat light-color-primary" i18n="@@pnlFrequently">
                        frequently
                      </span>
                    }
                    @if (item.carPark.misc.seoPageTransferTime) {
                      <span i18n="@@pnlAndTake">and take</span>
                    }
                    @if (item.carPark.misc.seoPageTransferTime) {
                      <span class="light-fat light-color-primary"
                        >{{ item.carPark.misc.seoPageTransferTime }} mins</span
                      >
                    }
                    .
                  }
                  <app-tooltips
                    [tooltipText]="item.carPark.information"
                    [ariaLabel]="'More information about ' + item.carPark.name"
                  ></app-tooltips>
                </div>
              </div>
            </div>
            <section class="container">
              <button
                id="parking-map-btn-{{ index }}"
                (click)="viewMapPage(item, index)"
                [attr.aria-label]="'Go to map view for ' + item.carPark.name"
                class="light-btn light-btn-ico light-btn-primary"
              >
                <i class="ico-map" aria-hidden="true"></i>
              </button>
            </section>
          </div>
          <div class="pnl-image">
            <img [src]="item.carPark.logo | removeSpaces" alt="{{ item.carPark.name }} logo" />
          </div>
          <div class="flex-row-container flex-row-container--between price-and-buttons">
            <div class="parking_results_rate">
              <span class="daily_rate">
                <span id="daily_rate_{{ index }}"> {{ item.price | number: '1.2-2' }} </span>
                <em>{{ item.currency }}</em>
              </span>
              <span class="rate_plan" i18n="@@carsTotalPrice"> Total Price </span>
              <app-warning-tags [iconId]="index" [ticket]="item"></app-warning-tags>
            </div>
            <div class="flex-column-container parking-buttons-wrapper">
              <button
                (click)="addToCart(item)"
                [disabled]="item.unavailable && !canOverride"
                appButton="small"
                id="parking-add-to-basket-{{ index }}"
                attr.aria-label="{{ item?.price | currency: item.currency || 'GBP' }} add to cart {{
                  item.carPark.name
                }}"
              >
                @if (!displayItinerary) {
                  <span i18n="@@pnlAddToCart">Add to basket</span>
                }
                @if (displayItinerary) {
                  <span i18n="@@pnlAddToItinerary">Add to itinerary</span>
                }
              </button>
              <button
                (click)="openParkingDetails(item)"
                appButton="small"
                id="parking-add-to-basket-{{ index }}"
                attr.aria-label="Additional details for {{
                  item?.price | currency: item.currency || 'GBP'
                }} {{ item.carPark.name }}"
              >
                <span i18n="@@pnlAdditionalDetails">Additional Details</span>
              </button>
            </div>
          </div>
        </div>
      </li>
    }
  </ul>
}
